module.exports = __webpack_public_path__ + "static/media/black_grey_chevron.bfbcd4ca.jpg";